import module from 'guest/module.js'
import template from './template.html'

class GuestNominasComponent {
  constructor ($state, GuestNominaDocumentoCfdi, GuestNominaDocumentoComprobante, GuestNominaDocumentoRecibo, GuestNominaDocumentoTirilla) {
    this.$state = $state
    this.GuestNominaDocumentoCfdi = GuestNominaDocumentoCfdi
    this.GuestNominaDocumentoComprobante = GuestNominaDocumentoComprobante
    this.GuestNominaDocumentoRecibo = GuestNominaDocumentoRecibo
    this.GuestNominaDocumentoTirilla = GuestNominaDocumentoTirilla
    this.idEmpresa = null
    this.idEmpleado = null
    this.fechaInicial = null
    this.fechaFinal = null
    this.idMoneda = null
    this.data = null
    this.monedas = null
  }

  $onInit () {
    this.filters = {
      inicio: this.fechaInicial,
      fin: this.fechaFinal,
      moneda: this.idMoneda,
    }

    this.catalogos = {
      monedas: this.monedas,
    }

    this.data = this.data.map((item) => {
      item.documentos = []

      if (item.Documentos.Documento_XML) {
        item.documentos.push({
          nombre: 'CFDI PDF',
          link: this.GuestNominaDocumentoCfdi.link(this.idEmpresa, this.idEmpleado, item.ID_Nomina, 'pdf'),
        })

        item.documentos.push({
          nombre: 'CFDI XML',
          link: this.GuestNominaDocumentoCfdi.link(this.idEmpresa, this.idEmpleado, item.ID_Nomina, 'xml'),
        })
      }

      if (item.Documentos.Documento_Tirilla) {
        item.documentos.push({
          nombre: 'Tirilla',
          link: this.GuestNominaDocumentoTirilla.link(this.idEmpresa, this.idEmpleado, item.Documentos.Documento_Tirilla),
        })
      }

      if (item.Documentos.Documento_Estado_Cuenta) {
        item.documentos.push({
          nombre: 'Balance Statement',
          link: this.GuestNominaDocumentoRecibo.link(this.idEmpresa, this.idEmpleado, item.ID_Nomina),
        })
      }

      if (item.Documentos.Documento_Comprobante_Deposito) {
        item.documentos.push({
          nombre: 'Transaction Receipt',
          link: this.GuestNominaDocumentoComprobante.get(this.idEmpresa, this.idEmpleado, item.Documentos.Documento_Comprobante_Deposito),
        })
      }

      return item
    })
  }

  buscar () {
    this.$state.go(this.$state.current, {
      inicio: this.filters.inicio.toYMD(),
      fin: this.filters.fin.toYMD(),
      moneda: this.filters.moneda,
    }, {reload: true})
  }
}

module.component('guestNominas', {
  controller: GuestNominasComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idEmpleado: '<',
    fechaInicial: '<',
    fechaFinal: '<',
    idMoneda: '<',
    data: '<',
    monedas: '<',
  },
})




// WEBPACK FOOTER //
// ./src/guest/components/nominas/component.js